export default __webpack_public_path__ + "static/media/DogIcon.5ae18a6d.svg";